import { PengurusGender } from "./graphql/generated";
import { toHumanReadable } from "./utils/string.ts";

export enum AppRoute {
  Home = "/",
  Login = "/login",
  AccessDenied = "/access-denied",
  UserAccessSetting = "/user-access-setting",
  ProfileSetting = "/profile-setting",
  TenantManagement = "/tenant-management",
  ActivityManagement = "/activity-management",
  LateFeeCalculator = "/late-fee-calculator",
  CollectionDashboard = "/collection-dashboard",
  ReviewAndApproval = "/review-and-approval",
  LimitRequest = "/limit-request",
  ClikData = "/clik-data",
  ClikDataCreate = `${AppRoute.ClikData}/create`,
  ClikResult = "/clik-result",
  EmployeeCandidate = "/employee-candidate",
  EmployeeCandidateCreate = `${AppRoute.EmployeeCandidate}/create`,
  RiskFunnelDashboard = "/risk-funnel-dashboard",
  SubmissionList = "/submission-list",
  CreditUnderwriting = "/credit-underwriting",
  RiskReview = "/risk-review",
  RiskMonitoring = "/risk-monitoring",
  Customers = "/customers",
  PropmtEditor = "/prompt-editor",
  RunAIAutomation = "/run-ai-automation",
  AIResult = "/ai-result-database",
  PaymasterAnalysis = "/paymaster-analysis",
  IDPForgeryCheck = "/idp-forgery-check",
  IDPDatabase = "/idp-database",
  KYC = "/kyc",
  KYCDetail = "/kyc/detail",
  ForgotPassword = "/forgot-password",
  LoginPasswordless = "/login/passwordless",
  DeskCollectionMessageTemplate = "/desk-collection/templates",
  DeskCollectionTools = "/desk-collection/tools",
  DeskCollectionDashboard = "/desk-collection/dashboard",
  TradeInsurance = "/trade-insurance",
}

export const CURRENCY = "IDR";

export const BABABOS_TENANT_ID = 1;

export const genderOptions = Object.values(PengurusGender).map((item) => ({
  value: item,
  label: toHumanReadable(item),
}));

export const boolSelectorOptions = [
  {
    value: "true",
    label: "True",
  },
  {
    value: "false",
    label: "False",
  },
];

export const yesNoOptions = [
  { value: "true", label: "Yes" },
  { value: "false", label: "No" },
];

export const API_DATE_FORMAT = "YYYY-MM-DD";

export const LATE_CHARGE_FEE = 0.002;
